//dropdown_values.js
// export const jobRoles = [
// 	{ label: "Senior Java Developer", value: "senior_java_developer" },
// 	{ label: "Junior Java Developer", value: "junior_java_developer" },
// 	{ label: "Junior AIML Developer", value: "junior_aiml_developer" },
// 	{ label: "Senior AIML Developer", value: "senior_aiml_developer" },
// 	{ label: "Junior DEVOPS Developer", value: "junior_devops_developer" },
// 	{ label: "Senior DEVOPS Developer", value: "senior_devops_developer" },
// 	{ label: "Junior EMBEDDED Developer", value: "junior_embedded_developer" },
// 	{ label: "Senior EMBEDDED Developer", value: "senior_embedded_developer" },
// 	{ label: "Senior SAP Developer", value: "senior_sap_developer" },
// 	{ label: "Junior SAP Developer", value: "junior_sap_developer" },
// ];



// export const domains = [
//   { label: "AI/ML", value: "aiml" },
//     { label: "Embedded", value: "embedded" },
//   { label: "DevOps", value: "devops" },
//   { label: "UI/UX", value: "uiux" },
//   { label: "Java", value: "java" },
//   { label: "SAP", value: "sap" },
//   { label: "IT Services & Consulting", value: "it_services_consulting" },
//   { label: "Software Product", value: "software_product" },
//   { label: "E-Commerce", value: "ecommerce" },
//   { label: "Hardware & Networking", value: "hardware_networking" },
//   { label: "Telecom", value: "telecom" },
//   { label: "Semiconductor", value: "semiconductor" },
//   { label: "Cyber Security", value: "cybersecurity" },
//   { label: "Cloud & SaaS", value: "cloud_saas" },
//   { label: "Datacenter", value: "datacenter" },
//   { label: "Gaming & Animation", value: "gaming_animation" },
//   { label: "FinTech", value: "fintech" },
//   { label: "EdTech", value: "edtech" },
//   { label: "HealthTech", value: "healthtech" },
//   { label: "Systems Integration", value: "systems_integration" },
//   { label: "BPM & ITES", value: "bpm_ites" },
//   { label: "IoT", value: "iot" },
//   { label: "Software Development", value: "software_development" },
//   { label: "Infrastructure & Cloud", value: "infra_cloud" },
//   { label: "Network Administration", value: "network_admin" },
//   { label: "Database Administration", value: "database_admin" },
//   { label: "Information Security", value: "infosec" },
//   { label: "QA & Testing", value: "qa_testing" },
//   { label: "Data Engineering", value: "data_engineering" },
//   { label: "Product Management", value: "product_management" },
//   { label: "Project Management", value: "project_management" },
//   { label: "Technical Support", value: "tech_support" },
//   { label: "ERP & CRM", value: "erp_crm" },
//   { label: "Mobile Development", value: "mobile_dev" },
//   { label: "Web Development", value: "web_dev" },
//   { label: "Business Analysis", value: "business_analysis" },
//   { label: "PreSales & Solution Architecture", value: "presales_solution_architecture" },
//   { label: "IT Consulting", value: "it_consulting" },
//   { label: "VLSI", value: "vlsi" }
// ];

// export const levels = [
//   "Junior",
//   "Senior",
// ];

// export const jobRoles = domains.flatMap(domain =>
//   levels.map(level => ({
//     label: `${level} ${domain.label} Engineer`,
//     value: `${level.toLowerCase()}_${domain.value}`
//   }))
// );

export const salaryRanges = [
	{ label: "0-5 LPA", value: "0-5 LPA" },
	{ label: "6-10 LPA", value: "6-10 LPA" },
	{ label: "11-15 LPA", value: "11-15 LPA" },
	{ label: "16-20 LPA", value: "16-20 LPA" },
	{ label: "21-25 LPA", value: "21-25 LPA" },
	{ label: "26-30 LPA", value: "26-30 LPA" },
	{ label: "30+ LPA", value: "30+ LPA" },
];

export const experiences = [
	{ label: "0-2", value: "0-2" },
	{ label: "3-5", value: "3-5" },
	{ label: "6-8", value: "6-8" },
	{ label: "9-11", value: "9-11" },
	{ label: "12-15", value: "12-15" },
	{ label: "15+", value: "15+" },
];

export const skills = [
	"Java",
    "SAP",
	"AI/ML",
	"DEVOPS",
	"EMBEDING SYSTEMS",
	"Python",	
	"JavaScript",
	"C language",
	"C++",
	"C#",
	"React",
	"HTML",
	"CSS",
	"SQL Server",
	"Oracle SQL",
	"MongoDB",	
	"LLM",
	"NLP",
	"Computer Vision",
	"Deep Learning",
	
];

export const secondarySkills = [
	"Java",
    "SAP",
	"AI/ML",
	"DEVOPS",
	"EMBEDING SYSTEMS",
	"Python",	
	"JavaScript",
	"C language",
	"C++",
	"C#",
	"React",
	"HTML",
	"CSS",
	"SQL Server",
	"Oracle SQL",
	"MongoDB",	
	"LLM",
	"NLP",
	"Computer Vision",
	"Deep Learning",	
];



export const overallFeedback = [
    { label: "Shortlisted from interview", value: "Interviewer_Selected" },
	{ label: "Rejected", value: "Interviewer_Rejected" },
    { label: "Hold", value: "Candidate_OnHold" },
    { label: "Another Round of Interview", value: "Round2_Suggested" },
];

export const countryOptions = [
	{ label: "🇮🇳 +91 (India)", value: "+91" },
	{ label: "🇺🇸 +1 (USA)", value: "+1" },
	{ label: "🇬🇧 +44 (UK)", value: "+44" },
	{ label: "🇦🇺 +61 (Australia)", value: "+61" },
	{ label: "🇦🇪 +971 (UAE)", value: "+971" },
	{ label: "🇯🇵 +81 (Japan)", value: "+81" },
  ];



  export const department = [
    { label: "IT", value: "IT" },
    { label: "HR", value: "HR" },
    { label: "Sales", value: "Sales" },
    { label: "Marketing", value: "Marketing" },
    { label: "Finance", value: "Finance" },
    { label: "Operations", value: "Operations" },
];